import {ChangeDetectionStrategy, Component, Input, ViewEncapsulation} from '@angular/core';
import {NavCrumb} from '../model/nav-tree';

const MAX_VISIBLE = 4;

/**
 * Where the page sits: Projects › project › group › entry › the page's own name. A long trail
 * keeps its ends and folds the middle behind a button that lists what it hid; a phone shows
 * only the way back to the parent.
 */
@Component({
  selector: 'app-nav-breadcrumb',
  templateUrl: './nav-breadcrumb.component.html',
  styleUrls: ['./nav-breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class NavBreadcrumbComponent {
  @Input() crumbs: NavCrumb[] = [];

  expanded = false;

  get folded(): boolean {
    return !this.expanded && this.crumbs.length > MAX_VISIBLE;
  }

  get head(): NavCrumb[] {
    return this.folded ? this.crumbs.slice(0, 1) : this.crumbs;
  }

  get hidden(): NavCrumb[] {
    return this.folded ? this.crumbs.slice(1, this.crumbs.length - 2) : [];
  }

  get hiddenLabels(): string {
    return this.hidden.map((crumb) => crumb.label).join(' › ');
  }

  get tail(): NavCrumb[] {
    return this.folded ? this.crumbs.slice(this.crumbs.length - 2) : [];
  }

  /** The nearest crumb above the current page that leads somewhere, for the phone's "‹ Parent". */
  get parent(): NavCrumb | null {
    return [...this.crumbs].reverse().find((crumb) => !crumb.current && crumb.path) || null;
  }

  get current(): NavCrumb | null {
    return this.crumbs[this.crumbs.length - 1] || null;
  }

  trackByLabel(index: number, crumb: NavCrumb): string {
    return `${index}:${crumb.label}`;
  }
}
